import React, { useCallback, useMemo } from 'react';
import Loader from 'react-simple-loading';

import PrivateGallery from '../PrivateGalleriesAndVideos/PrivateGallery';
import PrivateVideo from '../PrivateGalleriesAndVideos/PrivateVideo';
import LoadMore from '../../generalComponents/LoadMore';

import './PrivateGalleriesAndVideos.css';


const NAKED_NEWS_LIVE_ID = 241;


const PrivateGalleriesAndVideos = (props) => {
  const {
    anchorId,
    galleriesAndVideos,
    allAnchors,
    subscribed,
    user,
    handlePageChanged,
    isLoading,
    galleriesAndVideosCount,
    hiddenLibrariesCount,
    typeOfListing,
    payPerViewNav,
    openPayPerViewModal,
    isPurchasedTab,
    selectedClipPrice,
    isClipStorePage,
    anchorsWithClipStore,
    setPayPerViewClipData,
    isNakedNewsLive,
  } = props;

  const payPerViewTabClass = typeOfListing === 'clipstore' ? 'pay-per-view' : '';
  const purchasedTabClass = isPurchasedTab ? 'purchased' : 'new';
  const singleRowClass = typeOfListing !== 'clipstore' && galleriesAndVideosCount < 3 ? 'content-grid-single-row' : '';
  const shouldShowLoadMoreBtn = (galleriesAndVideos.length + hiddenLibrariesCount) < galleriesAndVideosCount;

  const getSubscriptionStatus = useCallback((item) => {
    const isNakedNewsLivePage = isNakedNewsLive || String(NAKED_NEWS_LIVE_ID) === String(item?.anchorId);
    if (isNakedNewsLivePage) {
      return user?.user?.account?.anchorSubscriptions?.
        filter((subscription) => subscription.subCategory === String(NAKED_NEWS_LIVE_ID)).length > 0;
    }
    

    return user?.user?.account?.anchorSubscriptions?.
      filter((subscription) => subscription.subCategory === String(item.anchorId)).length > 0;
  }, [user?.user?.account?.anchorSubscriptions, isNakedNewsLive]);

  const getAnchorId = useCallback((id) => {
    if (!(isClipStorePage || typeOfListing === 'clipstore') && anchorId === String(NAKED_NEWS_LIVE_ID)) {
      return NAKED_NEWS_LIVE_ID;
    }

    return id;
  }, [anchorId, isClipStorePage, typeOfListing]);


  const contentToRender = useCallback((item) => {
    const Component = item.type === 'VIDEO' ? PrivateVideo : PrivateGallery;

    return (
      <Component
        key={item.id}
        allAnchors={allAnchors}
        anchorId={getAnchorId(item.anchorId)}
        anchors={anchorsWithClipStore}
        blurContent={getSubscriptionStatus(item) === false}
        coverPhoto={item.imageUrl}
        date={item.date}
        freeForFanPlus={item.freeForFanPlus}
        imageCount={item.imageCount}
        isClipStorePage={isClipStorePage}
        isPurchasedTab={isPurchasedTab}
        media={item}
        openPayPerViewModal={openPayPerViewModal}
        payPerViewNav={payPerViewNav}
        price={item.priceToPay || item.price}
        selectedClipPrice={selectedClipPrice}
        setPayPerViewClipData={setPayPerViewClipData}
        subscribed={getSubscriptionStatus(item)}
        title={item.title}
        typeOfListing={typeOfListing}
        user={user}
      />
    );
  },
  [
    allAnchors,
    getAnchorId,
    anchorsWithClipStore,
    isClipStorePage,
    isPurchasedTab,
    openPayPerViewModal,
    payPerViewNav,
    selectedClipPrice,
    setPayPerViewClipData,
    getSubscriptionStatus,
    typeOfListing,
    user,
]);

  const MediaItems = useCallback(() => galleriesAndVideos.map((item) => (
    contentToRender(item)
  )), [contentToRender, galleriesAndVideos]);

  const LoadMoreContent = useCallback(() => {
    if (!shouldShowLoadMoreBtn) {
      return null;
    }

    if (!isLoading) {
      return (
        <LoadMore
          isLoading={isLoading}
          loadMore={handlePageChanged}
        />
      );
    }

    return (
      <Loader />
    );
  }, [handlePageChanged, isLoading, shouldShowLoadMoreBtn]);

  return (
    <div className={`container ${payPerViewTabClass} ${purchasedTabClass}`}>
      <div className="content-grid-container">
        <div className={`content-grid ${singleRowClass}`}>
          <MediaItems />
        </div>
        <div className="flex justify-center">
          <LoadMoreContent />
        </div>
      </div>
    </div>
  );
};

export default PrivateGalleriesAndVideos;

PrivateGalleriesAndVideos.defaultProps = {
  isNakedNewsLive: false
}
